import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetRequirementsResponse,
  RequirementQueryParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params: RequirementQueryParams
  onError: (error: Error) => void
  onSuccess: (response: GetRequirementsResponse) => void
  children?: (response: GetRequirementsResponse) => ReactElement
}

const GetRequirementRequest = ({
  params,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/requirements`

  const { requestParams } = useGetParamsWithSpaceId<RequirementQueryParams>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetRequirementRequest
